export default __webpack_public_path__ + "static/carvers-8ba7ab49750a79d7869c1baa63bd6649.png";